{
  "nl": {
    "onboarding": {
      "steps": {
        "name": {
          "heading": "Wat is je naam?",
          "headingInternational": "Welkom aan boord!",
          "paragraph": "We hebben je echte naam nodig voor de deelnamecertificaten.",
          "paragraphInternational": "Laat ons alsjeblieft je naam weten.",
          "submit": "Verder"
        },
        "international": {
          "heading": "Voor welke aanbiedingen ben je geïnteresseerd?",
          "submit": "Verder",
          "options": {
            "false": "Duitstalige aanbiedingen 🇩🇪 🇦🇹 🇨🇭",
            "true": "Engelstalige aanbiedingen 🌎"
          },
          "descriptions": {
            "false": "Aanbevolen voor personen die Duits spreken (groter aanbod aan nascholingen)",
            "true": "Aanbevolen voor personen die geen Duits spreken"
          }
        },
        "job": {
          "heading": "Wat beschrijft je rol het beste?",
          "paragraph": "Ik ben...",
          "submit": "Verder",
          "skip": "Later invullen"
        },
        "company": {
          "heading": "Waar werk je?",
          "submit": "Verder",
          "pleaseSelect": "Selecteer onderwijsinstelling",
          "noResults": "Geen resultaten. Voer je volledige postcode in."
        },
        "country": {
          "heading": "In welk land werk je?",
          "paragraph": "We willen je de beste service bieden voor jouw taal en schoolsysteem.",
          "submit": "Verder"
        },
        "grade": {
          "heading": "Waar geef je les?",
          "paragraph": "We hebben voor alle leeftijden en schooltypen nascholingen en webinars. Met deze informatie help je ons om de juiste inhoud aan te bevelen.",
          "submit": "Verder"
        },
        "region": {
          "heading": "Waar werk je?",
          "paragraph": "Met deze informatie help je ons om informatie en aanbiedingen specifiek voor jouw deelstaat aan te bevelen.",
          "submit": "Verder"
        },
        "subject": {
          "heading": "Welke schoolvakken geef je?",
          "paragraph": "We hebben voor alle leeftijden en schooltypen nascholingen en webinars. Met deze informatie help je ons om de juiste inhoud aan te bevelen.",
          "submit": "Verder"
        },
        "tool": {
          "heading": "Waar ben je het meest in geïnteresseerd?",
          "paragraph": "Met deze voorkeuren kunnen we je de beste aanbevelingen geven.",
          "submit": "Verder"
        },
        "infoFrom": {
          "heading": "Fijn dat je er bent!",
          "headingReOnboarding": "Dat was het! Bedankt voor je gegevens.",
          "subHeading": "Je aanmelding is gelukt.",
          "paragraph": "Nog één laatste vraag: Hoe heb je over fobizz gehoord?",
          "submit": "Aan de slag"
        }
      },
      "reOnboarding": {
        "heading": "Welkom terug bij fobizz!",
        "paragraph": "Om je passende aanbevelingen te kunnen doen, vragen we regelmatig of je gegevens nog actueel zijn.",
        "thanks": "Bedankt dat je er even de tijd voor neemt!",
        "start": "Aan de slag!",
        "skip": "Niet nu"
      },
      "labels": {
        "back": "Terug",
        "or": "of",
        "skip": "Overslaan",
        "pleaseSpecify": "Geef dit preciezer aan",
        "companyKind": "Onderwijsinstelling",
        "schoolType": "Schooltype",
        "country": "Land",
        "zipcode": "Postcode",
        "newCompany": "Mijn onderwijsinstelling staat er niet bij",
        "companyName": "Naam van de onderwijsinstelling (graag voluit schrijven, geen afkorting)",
        "customSchoolType": "Overig schooltype",
        "customCompany": "Bij welke instelling ben je werkzaam?",
        "street": "Straat, huisnummer",
        "city": "Stad",
        "searching": "Zoeken ...",
        "activate": "Activeren"
      },
      "enums": {
        "infoFromType": {
          "school_administration": "Schoolleiding",
          "colleagues": "Team",
          "instagram": "Instagram",
          "twitter": "Twitter",
          "facebook": "Facebook",
          "pinterest": "Pinterest",
          "linkedin": "LinkedIn",
          "online_search": "Zoeken op internet",
          "ai_assistant": "AI-Assistent",
          "social_media": "Sociale media",
          "podcast": "Podcast",
          "event": "Evenement, beurs of lezing",
          "custom": "Overig"
        },
        "regionCode": {
          "BW": "Baden-Württemberg",
          "BY": "Beieren",
          "BE": "Berlijn",
          "BB": "Brandenburg",
          "HB": "Bremen",
          "HH": "Hamburg",
          "HE": "Hessen",
          "MV": "Mecklenburg-Voor-Pommeren",
          "NI": "Nedersaksen",
          "NW": "Noordrijn-Westfalen",
          "RP": "Rijnland-Palts",
          "SL": "Saarland",
          "SN": "Saksen",
          "ST": "Saksen-Anhalt",
          "SH": "Sleeswijk-Holstein",
          "TH": "Thüringen"
        },
        "toolsByValue": {
          "1": "AI Tools",
          "2": "Lesmateriaal ontdekken",
          "3": "Online nascholingen",
          "4": "AI Tools voor leerlingen",
          "5": "Eigen digitaal materiaal maken"
        }
      }
    }
  }
}
